var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertRedQuarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.6 72.8",
    style: {
      enableBackground: "new 0 0 8.6 72.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE3823;}\n\t.st1{fill:#9CB6B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0,
    className: "st0",
    width: 8.6,
    height: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,72.8H0.2v-12h8.5V72.8z M8.7,48.8H0.2v-12h8.5V48.8z M8.7,24.8H0.2v-12h8.5V24.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertRedQuarter);
export default __webpack_public_path__ + "static/media/Vert-red-quarter.967ad5bf3348589a6e9ea16d5aa7d670.svg";
export { ForwardRef as ReactComponent };